import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-icon-w",
  "use": "close-icon-w-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"close-icon-w\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M.157 11.616a.535.535 0 010-.757L10.719.297a.535.535 0 11.757.757L.913 11.616a.534.534 0 01-.756 0z\" /><path d=\"M11.097 11.773a.534.534 0 01-.378-.157L.157 1.054A.535.535 0 11.914.297l10.562 10.562a.535.535 0 01-.379.914\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol